import { useContext, useEffect, useState } from 'react'
import { StatCard } from './StatCard'
import { PlayerProfileContext } from '../../../../../../Context'
import { StatCardProps } from './types'
import { calculateCoreStats } from '../../../../../../Utils/Players/playerStatHelpers'
import { CoreStatsRow } from './styles'

export const CoreStats: React.FC = () => {
  const { player, seasonStats, getStats } = useContext(PlayerProfileContext)!
  const [coreStats, setCoreStats] = useState<StatCardProps[]>([])

  useEffect(() => {
    if (!player || !seasonStats) return
    const statsForSeason = getStats('season', false, seasonStats)
    const calculatedStats = calculateCoreStats(player, statsForSeason)
    setCoreStats(calculatedStats)
  }, [player, seasonStats])

  if(coreStats.length === 0) return null

  return (
    <CoreStatsRow>
      {coreStats.map((statProps) => (
        <StatCard key={statProps.statName} {...statProps} />
      ))}
    </CoreStatsRow>
  )
}
